import { ProfileApis } from '../../../API/Login/ProfileApi'
import { UsersApis } from '../../../API/Login/UsersApi'
import ErrorHandle from '../../../Components/ErrorHandle'
import {
  getLoggedInUserBuddiesList,
  getLoggedInUserFollowersList,
  getLoggedInUserFollowingList,
} from '../Driverbuddyprofile/helper'

export const ProfileMethods = {
  getUserProfileImage: (frProUser, setFrProUser, setToasts) => {
    // let token = {
    //   fre8ProAccessToken: frProUser?.fre8ProAccessToken,
    // }
    const userProfileImgObj = {
      fre8ProAccessToken: frProUser?.fre8ProAccessToken,
      userId: frProUser?.userId,
      profileId: frProUser?.profileId,
      operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
      operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
      clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
    };
    ProfileApis.userProfileImage(userProfileImgObj)
      .then((res) => {
        setFrProUser({
          frProUser: {
            ...frProUser,
            profileImg: res?.data?.profileImageUrlList?.at(-1) || '',
          },
        })
      })
      .catch((err) => {
        console.log('error', err)
        let customMessage = 'User profile image update failed'
        let type = 'User Information'
        let color = 'red'
        ErrorHandle(err, setToasts, customMessage, type, color)
      })
  },

  getOtherUserProfileForDetailedInfoAboutUser: async (
    userId,
    frProUser,
    setToasts
  ) => {
    // let userObj = {
    //   userId: userId,
    //   fre8ProAccessToken: frProUser?.fre8ProAccessToken,
    // }
    const userObj = {
      fre8ProAccessToken: frProUser?.fre8ProAccessToken,
      userId: userId,
      profileId: frProUser?.profileId,
      operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
      operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
      clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
    }
    UsersApis.getUserProfileOfOtherUser(userObj)
      .then((res) => {
        return res?.data
      })
      .catch((err) => {
        console.error(
          'Error in get User Profile Of O ther User from compoennet',
          err
        )
        let customMessage = 'User Profile Of Other User failed'
        let type = 'User Information'
        let color = 'red'
        ErrorHandle(err, setToasts, customMessage, type, color)

        return err?.data
      })
  },

  getFollowersList: (frProUser, setToasts) => {
    let followerList = getLoggedInUserFollowersList(frProUser, setToasts)
    console.log('followers list', followerList)
  },
  getBuddiesList: (frProUser, setToasts) => {
    let buddiesList = getLoggedInUserBuddiesList(frProUser, setToasts)
    console.log('Buddies list', buddiesList)
  },

  getFollowingList: (frProUser, setToasts) => {
    let followingList = getLoggedInUserFollowingList(frProUser, setToasts)
    console.log('followers list', followingList)
  },
}
